import { render, staticRenderFns } from "./RightAlertPanel.vue?vue&type=template&id=96b0e2ac&scoped=true&"
import script from "./RightAlertPanel.vue?vue&type=script&lang=js&"
export * from "./RightAlertPanel.vue?vue&type=script&lang=js&"
import style0 from "./RightAlertPanel.vue?vue&type=style&index=0&id=96b0e2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b0e2ac",
  null
  
)

export default component.exports